import { v4 as uuidv4 } from 'uuid';

import { reportUsageV2 } from '../../../api/usageV2';
import { QuestionSearchSubmittedProps } from '../events/searchEvents.types';
import { getTimeFromSearchConversationStart } from '../getTimeFromSearchConversationStart';
import { loadProtobuf } from '../lazyExports';

const packageName = 'events';
const eventName = 'QuestionSearchSubmittedV1';
const emptyId = 'ERROR - no-conversation-id';

type ReportQuestionSearchSubmitted = (props: QuestionSearchSubmittedProps) => void;
export const reportQuestionSearchSubmitted: ReportQuestionSearchSubmitted = async ({
  conversationId,
  logicalId,
  queryLength,
  wordCount,
  conversationStart,
}) => {
  const { events } = await loadProtobuf();

  const timeToActionMilliseconds = getTimeFromSearchConversationStart(conversationStart);

  const questionSearchSubmittedProps = {
    conversationId: conversationId ?? emptyId,
    logicalId: logicalId ?? uuidv4(),
    length: queryLength,
    wordCount,
    timeToActionMilliseconds,
  };

  const questionSearchSubmitted = events.QuestionSearchSubmittedV1.encode(questionSearchSubmittedProps).finish();

  reportUsageV2({
    packageName,
    eventName,
    value: questionSearchSubmitted,
  });
};
